module.exports = __webpack_public_path__ + "static/media/flag-am.3a0fe6f2.webp";